import Navbar from "../Components/Navbar";
import img1 from "../Assets/image 3.png";
import img from "../Assets/1721270706-bpfull 8.png";
import img2 from "../Assets/image 4.png";
import img3 from "../Assets/image 5.png";
import join from "../Assets/Screenshot 2025-01-15 155859.png";
import pero from "../Assets/image 7.png";
import img4 from "../Assets/rb_2148528539.png";
import icon2 from "../Assets/pngwing.com (66) 1.png";
import icon1 from "../Assets/pngwing.com (67) 1.png";
import React, { useEffect, useState, useRef } from "react";
import img5 from "../Assets/follow-me-social-business-theme-design_24877-50423 1.png";
import img6 from "../Assets/1d7e3569-40cf-4ecc-b0d0-84f9b6e7a21b_1024-removebg-preview.png";
import Footer from "../Components/Footer";
import newicon from '../Assets/Knowledge-icon.png'
import newicon2 from '../Assets/h1.png'
import newicon3 from '../Assets/h2.png'
import newicon4 from '../Assets/h3.png'

import { Link, useNavigate } from "react-router-dom";
import { apiGet } from "../ApiUrls";
// import img6 from '../Assets/main.mp4'
import ContentLoader from 'react-content-loader';
import nrw from '../Assets/dating.gif'
import SEOData from "../Components/SEOData";
const faqData = [
  {
    question: "I would like to meet a hostess/Model, what can i ask?",
    answer:
      "The hostesses/models on our site are not escorts, and requests/offers of sexual services are not tolerated. The services offered include companionship for dinners, aperitifs, events, trips, holidays, photo shoots, hostess services, ",
  },
  {
    question: "Hostess/Models Rates?",
    answer:
      "You can track your order using the tracking number provided in the confirmation email.",
  },
  {
    question: "Privacy and confidentiality?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Credits, costs and refunds?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Dating and Security?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
  {
    question: "Are consultations available outside regular business hours?",
    answer:
      "Yes, we ship internationally. Shipping rates and delivery times may vary.",
  },
];

function Home() {
  const sliderRef = useRef(null);

  const navigate = useNavigate()
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const [AllModels, setAllModels] = useState([]);
  const [IsUploading, setIsUploading] = useState(false);

  const GetAllHostess = async () => {
    try {
      setIsUploading(true);
      const response = await apiGet(`api/user/GetAllHostess`);
      setAllModels(response?.data);
      setIsUploading(false);
    } catch (error) {
      setIsUploading(false);
      console.log(error);
    }
  };
  useEffect(() => {
    GetAllHostess();
  }, []);
  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };

  const ModelDetailPage = (id) => {
    navigate(`/ModelDetail/${id}`)
  }

  return (
    <div >
      <Navbar />
      <SEOData PageName={'Home'} />
      <div className="banner">
        <video autoPlay muted loop id="background-video">
          <source
            src="https://resources.tango.me/web/main-landing-page-video.mp4"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>

        <div className="overlay">
          <h1>
            The n.1 community of
            <br /> Hostesses, Models and <br /> <span>WingWoman</span>
          </h1>
          <br />

          <p>
            With Wostess you can connect with professional hostesses and models
            <br />
            who are also available to accompany you to dinners, events, and
            trips. Enjoy
            <br />
            direct contact without intermediaries
          </p>
          <br />

          <div className="banner-div">
            <Link to="/allmodal">
              <button>Explore Now</button>
            </Link>
          </div>
        </div>
      </div>
      <div className="ml-pl">

        <div className="date-div">
          <div className="date-div-left">

            <img src={nrw} />
          </div>
          <div className="date-div-right">
            <div className="AboutUs">
              <div className="About-btn">
                <h3>About Us</h3>
              </div>
              <h2>
                Welcome to Hostess, where big and beautiful love blossoms! We're here to create a better, more meaningful dating experience by connecting hearts, one date at a time. At Hostess, we believe in building relationships that matter in a supportive, inclusive, and uplifting environment.
                <br />
                <br />
                Join us on this journey to find someone special, because love deserves a beautiful beginning—with Hostess.
              </h2>
            </div>
          </div>
        </div>
      </div>


      <div className="ml-pl">
        <div className="models">
          <div className="models-heading">
            <h2>Independent Hostesses and Models</h2>
            <p>
              Get in touch directly with hostesses and models in your area. Plan
              aperitifs, dinners, events, photoshoots and trips.
            </p>
          </div>
          <br />
          <br />
          <div className="slider-container">
            <div>
              <button className="scroll-button left" onClick={scrollLeft}>
                <i class="bi bi-arrow-left-short"></i>

              </button>
            </div>
            <div className="modal-slider" ref={sliderRef}>
              {IsUploading ? (
                <ContentLoader viewBox="0 0 820 450" height={'100%'} width={'100%'}>
                  <rect x="10" y="10" rx="5" ry="5" width="260" height="280" />
                  <rect x="280" y="10" rx="5" ry="5" width="260" height="280" />
                  <rect x="550" y="10" rx="5" ry="5" width="260" height="280" />
                </ContentLoader>
              ) : (
                AllModels.map((model) => (
                  <div onClick={() => { ModelDetailPage(model?._id) }} key={model._id}>
                    <div
                      style={{
                        backgroundImage: `url(${model?.Gallary?.length === 0 ? img : model?.Gallary[0]})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}

                      className="modal-card">
                      <div className="modal-overlay2">

                        <h3 style={{ color: 'white' }}>{model.UserName}</h3>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <div>

              <button className="scroll-button right" onClick={scrollRight}>
                <i class="bi bi-arrow-right-short"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="whyus">
        <div className="whyus-heading">
          <h3>Why Choose Hostess?</h3>
          <p>
            Hostess offers you a wide selection of hostesses and models
            available for events, dinners, and trips.
          </p>
        </div>
        <br />
        <br />
        <br />
        <br />
        {/* <div className="join-now">
          <div className="join-now-left">
            <h2 style={{ textAlign: "center" }}>Join Us</h2>

            <p>
              At Hostess, we redefine connections by providing a trusted
              platform where authenticity meets convenience. Our community is
              built on verified profiles, ensuring genuine interactions and
              meaningful relationships. With no intermediaries involved, you
              enjoy direct communication with hostesses and models for dinners,
              events, or travel. We prioritize transparency, offering clear
              services without hidden costs, automatic refunds for unanswered
              chats, and 24/7 support for your peace of mind. Whether you're
              seeking companionship or opportunities, Hostess delivers a
              secure, user-friendly experience tailored to your needs. Join us
              today and discover the difference of a platform that values trust,
              privacy, and seamless interactions.
            </p>
          </div>
          <div className="join-now-right">
            <img src={join} />
          </div>
        </div> */}
        <div className="why-boxs">
          <div className="why-div">

            <div className="why-box">
              <img src={newicon} />
              <br />
              <h3>Join Now</h3>
              <br />
              <p>Access all available profiles and private photos.</p>

            </div>
          </div>
          <div className="why-div">

            <div className="why-box">
              <img src={newicon2} />
              <br />
              <h3>Search Nearby</h3>
              <br />
              <p>Enter your city and we will show you the profiles closest to you.</p>

            </div>
          </div>
          <div className="why-div">

            <div className="why-box">
              <img src={newicon3} />
              <br />
              <h3>Unlock Chat</h3>
              <br />
              <p>Unlock the chats and connect directly.</p>

            </div>
          </div>
          <div className="why-div">

            <div className="why-box">
              <img src={newicon4} />
              <br />
              <h3>Enjoy :)</h3>
              <br />
              <p>Remember that hostesses and models are not escorts and are performing a job.</p>

            </div>

          </div>

        </div>
        <br />
        <br />
      </div>
      <div className="signup-div">
        <img src={pero} />
        <h3>Sign up for free and access all the features</h3>
        <Link to="/signup">
          <button>Sign up Now</button>
        </Link>
      </div>

      <div className="network">
        <div className="network-left">
          <img src={img4} />
        </div>
        <div className="network-right">
          <h3>Work with Fun and expand your Network</h3>

          <p>
            Are you a hostess or model seeking exciting opportunities, or
            looking to kickstart your career? At Hostess, you can work
            independently, connect with clients directly, and earn by
            accompanying them to dinners, events, photoshoots, or trips—all with
            no hidden costs or commissions. Enjoy the freedom to set your own
            terms while expanding your network and exploring diverse
            experiences. Whether you're a seasoned professional or just starting
            out, Hostess offers a platform designed for growth, flexibility,
            and rewarding connections. Sign up today and turn your passion into
            profit!
          </p>
          <br />
          {/* <Link to="/signup">
            <button>Sign up Now</button>
          </Link> */}
        </div>
      </div>
      {/* <div className='real-profiles'>
<div className='real-profiles-left'>
<h3>Only real profiles</h3>
<br/>
<p>Hostess.com is a community that values trust above all. Profiles are verified using advanced AI tools and our Verification Team.</p>
<br/>
<br/>
<br/>
<div className='whatif'>
<div className='whatif-div'>
<img src={icon1}/>
<br/>
<h4>What if I don’t get a response?</h4>
<p>We provide an automatic refund for all unanswered chats after 72 hours and are always available to review any requests.</p>

</div>
<div className='whatif-div'>
<img src={icon2}/>
<h4>24/7 support</h4>
<p>Our Customer Support is active 24/7 to assist you at any time.</p>


</div>
</div>

</div>
<div className='real-profiles-right'>
<img src={img5}/>

</div>

</div> */}
      {/* <div className="only">
        <div className="whyus-heading">
          <h3>Only real profiles</h3>
          <p style={{paddingTop: "16px"}}>
            Hostess.com is a community that values trust above all. <br />
            Profiles are verified using advanced AI tools and our Verification
            Team.
          </p>
        </div>
        <br />
        <br />
        <br />
        <div className="only-cards">
          <div className="only-card">
            <div className="only-circle">
              <h2>200 +</h2>
            </div>
            <div className="only-sq">
              <p>Verified Profiles</p>
              <h4>
                Our dedicated Verification Team ensures authenticity and
                accuracy.
              </h4>
            </div>
          </div>
          <div className="only-card">
            <div className="only-circle">
              <h2>200 +</h2>
            </div>
            <div className="only-sq">
              <p>Verified Profiles</p>
              <h4>
                Our dedicated Verification Team ensures authenticity and
                accuracy.
              </h4>
            </div>
          </div>
          <div className="only-card">
            <div className="only-circle">
              <h2>200 +</h2>
            </div>
            <div className="only-sq">
              <p>Verified Profiles</p>
              <h4>
                Our dedicated Verification Team ensures authenticity and
                accuracy.
              </h4>
            </div>
          </div>
          <div className="only-card">
            <div className="only-circle">
              <h2>24/7 </h2>
            </div>
            <div className="only-sq">
              <p>Support</p>
              <h4>
                Our support team is available around the clock to assist with
                any queries or issues.
              </h4>
            </div>
          </div>
        </div>
      </div> */}

      <div className="faq">
        <div className="faq-heading">
          <h3>Frequently Asked Question</h3>
          <br />
          <br />
          <div className="faq-div">
            <div className="faq-div-left">
              <img src={img6} />
            </div>
            <div className="faq-div-right">
              <div className="accordion">
                {faqData.map((faq, index) => (
                  <div className="accordion-item" key={index}>
                    <div
                      className="accordion-header"
                      onClick={() => toggleAccordion(index)}
                    >
                      <button className="accordion-toggle">
                        <h3>
                          {" "}
                          <span>{openIndex === index ? "-" : "+"}</span>{" "}
                          {faq.question}
                        </h3>
                      </button>
                    </div>
                    <div
                      className="accordion-content"
                      style={{ maxHeight: openIndex === index ? "100px" : "0" }}
                    >
                      <p>{faq.answer}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
